(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var main = new Splide('#main-slider', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    var thumbnails = new Splide('#thumbnail-slider', {
      fixedWidth: 167,
      fixedHeight: 167,
      isNavigation: true,
      gap: 10,
      direction: 'ttb',
      height: '530px',
      pagination: false,
      arrows: false,
      breakpoints: {
        767: {
          direction: 'ltr',
          fixedWidth: 100,
          fixedHeight: 100,
          height: 'auto',
        },
      },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  });
  } catch(e) { console.error(e); }
})();

})();
